import { render, staticRenderFns } from "./ReserveDetailCard.vue?vue&type=template&id=1d07a63f&scoped=true"
import script from "./ReserveDetailCard.vue?vue&type=script&lang=js"
export * from "./ReserveDetailCard.vue?vue&type=script&lang=js"
import style0 from "./ReserveDetailCard.vue?vue&type=style&index=0&id=1d07a63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d07a63f",
  null
  
)

export default component.exports